<template><AnnouncementCarousel /></template>
<script>
import AnnouncementCarousel from '@/components/common/AnnouncementCarousel'
export default { components: { AnnouncementCarousel } }
</script>
